import { getStaticImage } from 'utils/statics'

export const getClassNames = (params = {}) => {
  const { isOpen, theme = 'primary', className } = params
  let classNameValue = `
    collapsible-container
    collapsible-container--${isOpen ? 'open' : 'closed'}
    collapsible-container--${theme}
  `
  if (className) classNameValue = classNameValue + ` ${className}`
  return classNameValue
}

export const getArrowIcon = (theme = 'primary') => {
  if (theme === 'primary') return getStaticImage('/icons/orange-brand/icon-arrow-down-rounded-primary-dark.svg')
  if (theme === 'dark') return getStaticImage('/icons/orange-brand/icon-arrow-down-rounded-dark.svg')
  return ''
}

export const getBodyStyle = (params = {}) => {
  const { isOpen, maxHeight = 0 } = params
  return { maxHeight: isOpen ? maxHeight : 0 }
}
